import {
  CircularProgress,
  Dialog,
  DialogContent,
  type DialogProps,
  Flex,
  Text,
} from '@shared/components';

export type PrintExaminationCodeLoadingModalProps = Pick<DialogProps, 'open'>;

export default function PrintExaminationCodeLoadingModal(
  props: Readonly<PrintExaminationCodeLoadingModalProps>,
) {
  const { open: isOpen } = props;
  return (
    <Dialog open={isOpen} sx={{ '& .MuiPaper-root': { width: '378px' } }}>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: theme.spacing(4),
        })}
      >
        <CircularProgress />
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1), textAlign: 'center' })}
        >
          <Text variant='h5'>กำลังโหลดใบแจ้งรหัสการสอบ</Text>
          <Text color='secondary'>กรุณารอสักครู่ ระบบกำลังเตรียมเอกสารให้คุณ</Text>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
